import { Box } from "@stenajs-webui/core";
import { PrimaryButton } from "@stenajs-webui/elements";
import { ModalFooter } from "@stenajs-webui/modal";
import type { FC } from "react";
import { useSelector } from "react-redux";

import type { DetailedIntermodalBooking } from "../../../common/graphql/fragments/gql/IntermodalBooking";
import { useEditable } from "../../../common/modal/EditableContext";
import { PRINT_HIDE_CLASSNAME } from "../../../globalStyles";
import { useUpdateIntermodalBooking } from "../../../services/intermodal/hooks/useUpdateIntermodalBooking";
import { getUpdateIntermodalFormIsEdited } from "../../../services/intermodal/updateIntermodalReducer";
import { IntermodalCancelButton } from "./IntermodalCancelButton";

interface IntermodalBookingUpdateFooterProps {
  booking: DetailedIntermodalBooking;
  refetch: () => void;
}

export const IntermodalBookingUpdateFooter: FC<
  IntermodalBookingUpdateFooterProps
> = ({ booking, refetch }) => {
  const editable = useEditable();
  const edited = useSelector(getUpdateIntermodalFormIsEdited);
  const { submit, loading } = useUpdateIntermodalBooking(refetch);

  const cancellable = booking.cancellable;

  if (!editable && !cancellable) {
    return null;
  }

  return (
    <ModalFooter sticky className={PRINT_HIDE_CLASSNAME}>
      <Box
        flexDirection={["column", null, "row"]}
        flex={1}
        justifyContent={"space-between"}
        gap
      >
        {cancellable && <IntermodalCancelButton booking={booking} />}
        {editable && (
          <PrimaryButton
            label={"Save changes"}
            className={"t_intermodal_save_button"}
            loadingLabel={"Saving..."}
            disabled={!edited}
            loading={loading}
            onClick={() => {
              submit();
            }}
          />
        )}
      </Box>
    </ModalFooter>
  );
};
